<div class="row">
  <div class="col-4">
    <rask-header underline>Åtgärdsgeometri</rask-header>
    <div class="row mb-4">
      <div class="col">
        <rask-input label="Åtgärdsbeteckning" [(ngModel)]="searchText"></rask-input>
        <rask-radiobutton-group
          [buttons]="[{ key: 'virkeskop', value: 'Virkesköp' }, { key: 'arbetsorder', value: 'Arbetsorder' }]"
        [(ngModel)]="feature"></rask-radiobutton-group>
        <rask-button color="secondary" [disabled]="working" (click)="search()">Ladda åtgärd</rask-button>
        @if (working) {
          <rask-busy-spinner size="1"></rask-busy-spinner>
        }
        <div>{{ errorText }}</div>
      </div>
    </div>
    @if (isAtgardLoaded === true) {
      <div class="row mb-4">
        <div class="col">
          <rask-input-number [disabled]="working" label="Meter" [isDecimal]="true" [step]="0.01" [min]="0"
          [max]="1" [(ngModel)]="bufferMeters"></rask-input-number>
          <rask-button [disabled]="working" color="secondary" (click)="makeBuffer()">Buffer</rask-button>
        </div>
      </div>
    }
    @if (isAtgardLoaded === true) {
      <div class="row mb-4">
        <div class="col">
          <rask-input-number [disabled]="working" label="Meter" [isDecimal]="true" [step]="0.01" [min]="0"
          [max]="1" [(ngModel)]="simplifyMeters"></rask-input-number>
          <rask-button [disabled]="working" color="secondary" (click)="makeSimplify()">Simplify</rask-button>
        </div>
      </div>
    }
  </div>
  <div class="col-8">
    <rask-map [settings]="mapsettings">
      <rask-map-measure></rask-map-measure>
      <rask-map-layers></rask-map-layers>
    </rask-map>
  </div>
</div>